import Skeleton from 'react-loading-skeleton';
import styles from './styles.module.css';

const PostSliderLoader = (): React.JSX.Element => {
  return <Skeleton width={840} height={450} className={styles.skeleton} />;
};

export default PostSliderLoader;
